export default "__VITE_ASSET__Bp5fQwyE__"